import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBubbleLoading = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 192,
	height: 192,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 2,
			r: 0,
			fill: props.fill,
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "r",
				begin: 0,
				calcMode: "spline",
				dur: "1s",
				keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
				repeatCount: "indefinite",
				values: "0;2;0;0"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 2,
			r: 0,
			fill: props.fill,
			transform: "rotate(45 12 12)",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "r",
				begin: "0.125s",
				calcMode: "spline",
				dur: "1s",
				keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
				repeatCount: "indefinite",
				values: "0;2;0;0"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 2,
			r: 0,
			fill: props.fill,
			transform: "rotate(90 12 12)",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "r",
				begin: "0.25s",
				calcMode: "spline",
				dur: "1s",
				keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
				repeatCount: "indefinite",
				values: "0;2;0;0"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 2,
			r: 0,
			fill: props.fill,
			transform: "rotate(135 12 12)",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "r",
				begin: "0.375s",
				calcMode: "spline",
				dur: "1s",
				keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
				repeatCount: "indefinite",
				values: "0;2;0;0"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 2,
			r: 0,
			fill: props.fill,
			transform: "rotate(180 12 12)",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "r",
				begin: "0.5s",
				calcMode: "spline",
				dur: "1s",
				keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
				repeatCount: "indefinite",
				values: "0;2;0;0"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 2,
			r: 0,
			fill: props.fill,
			transform: "rotate(225 12 12)",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "r",
				begin: "0.625s",
				calcMode: "spline",
				dur: "1s",
				keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
				repeatCount: "indefinite",
				values: "0;2;0;0"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 2,
			r: 0,
			fill: props.fill,
			transform: "rotate(270 12 12)",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "r",
				begin: "0.75s",
				calcMode: "spline",
				dur: "1s",
				keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
				repeatCount: "indefinite",
				values: "0;2;0;0"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 2,
			r: 0,
			fill: props.fill,
			transform: "rotate(315 12 12)",
			children: /* @__PURE__ */ _jsx("animate", {
				attributeName: "r",
				begin: "0.875s",
				calcMode: "spline",
				dur: "1s",
				keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
				repeatCount: "indefinite",
				values: "0;2;0;0"
			})
		})
	]
});
export default SvgBubbleLoading;
